import * as TyreReregistrationOrderModels from '../../models/tyre-reregistration-order/tyre-reregistration-order';
import { TyreReregistrationOrderSearchModel } from '../../models/tyre-reregistration-order/tyre-reregistration-orderSearch';
import * as Models from '../../models/commonModels';

export class GetList {
  static readonly type = '[TyreReregistrationOrder] List';
  constructor(public Search: TyreReregistrationOrderSearchModel) { }
}

export class SetSearch {
  static readonly type = '[TyreReregistrationOrder] Set Search';
  constructor(public Search: TyreReregistrationOrderSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[TyreReregistrationOrder] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[TyreReregistrationOrder] Set List Page';
  constructor(public Search: TyreReregistrationOrderSearchModel) { }
}

export class GetStatusDictionary {
  static readonly type = '[TyreReregistrationOrder] Get Status Dictionary';
  constructor() { }
}

export class GetFilteredReport {
  static readonly type = '[TyreReregistrationOrder] GetFilteredReport';
  constructor(public Search: TyreReregistrationOrderSearchModel) { }
}

export class DisposeSearch {
  static readonly type = '[TyreReregistrationOrder] DisposeSearch';
  constructor() { }
}

export class Set {
  static readonly type = '[TyreReregistrationOrder] Set';
  constructor(public Order: Models.Request<TyreReregistrationOrderModels.TyreReregistrationOrderModel>) { }
}

export class Get {
  static readonly type = '[TyreReregistrationOrder] Get';
  constructor(public OrderId: Models.RequestModel) { }
}
